import React from 'react'
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2019 - 2024</p>
          <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Web Development & Automation"
            subTitle="Self Taught (2021 - 2024)"
            result="3.90/4"
            des="Self-driven learning and hands-on practice in development and automation to independently gain the skills needed to solve real-world problems across industries, without formal university training."
          />
          <ResumeCard
            title="Diploma in Information Technology"
            subTitle="Modi Training Institue (2019 - 2020)"
            result="4.75/5"
            des="Learned about the latest technology trends and how to apply them to the
            business world."
          />
          <ResumeCard
            title="Intermediate Education"
            subTitle="UP Board (2020 - 2021)"
            result="4.95/5"
            des="I have learned the basics of computer science and programming."
          />
        </div>
      </div>
      {/* part Two */}

      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023 - 2025</p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Automation Specialist"
            subTitle="Meddey Technology Pvt Ltd - (2024 - Present)"
            result="New Delhi"
            des="From web scraping and order tracking to ad automation, I help businesses save time, reduce manual work, and improve efficiency. I also create a two website for this company."
          />
          <ResumeCard
            title="Ecommerce Executive"
            subTitle="Golden Age Media - (2023 - 2024)"
            result="New Delhi"
            des="I managed the company's e-commerce website, ensuring that products were displayed correctly, orders were processed efficiently, and customers were satisfied."
          />
          <ResumeCard
            title="Content Creator"
            subTitle="Youtube - (2020 - 2022)"
            result="New Delhi"
            des="I created and uploaded videos on a variety of topics, including technology, education, and entertainment, gaining over 80,000 subscribers and 8 million views."
          />
        </div>
      </div>
    </motion.div>
  );
}

export default Education